var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconCheckCircleFillComponent(props, ref) {
    var prefixFromContext = useContext(Context).prefix;
    var _a = props.className, className = _a === void 0 ? '' : _a, prefixFromProps = props.prefix, _b = props.width, width = _b === void 0 ? '1em' : _b, _c = props.height, height = _c === void 0 ? '1em' : _c, _d = props.useCurrentColor, useCurrentColor = _d === void 0 ? true : _d, spin = props.spin, rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor", "spin"]);
    var prefix = prefixFromProps || prefixFromContext || 'arco';
    var loadingKls = spin ? " ".concat(prefix, "-icon-loading") : '';
    return React.createElement("svg", __assign({ className: "".concat(prefix, "-icon ").concat(prefix, "-icon-check_circle_fill").concat(loadingKls, " ").concat(className), width: width, height: height, viewBox: "0 0 16 16", fill: useCurrentColor ? 'currentColor' : '#000', xmlns: "http://www.w3.org/2000/svg" }, rest, { ref: ref }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.99992 15.3325C12.0495 15.3325 15.3324 12.0496 15.3324 8.00004C15.3324 3.95045 12.0495 0.667603 7.99992 0.667603C3.95033 0.667603 0.66748 3.95045 0.66748 8.00004C0.66748 12.0496 3.95033 15.3325 7.99992 15.3325ZM11.4648 5.11124L10.7532 4.66407C10.5549 4.54353 10.2944 4.60186 10.1739 4.80017L7.10978 9.70346L5.41055 7.76314C5.25501 7.58816 4.9906 7.56872 4.81951 7.72037L4.18181 8.27641C4.00683 8.42806 3.98739 8.70025 4.14292 8.87134L6.58874 11.6671C6.76371 11.8693 7.02035 11.9743 7.28476 11.951C7.55306 11.9315 7.79026 11.7838 7.93413 11.5543L11.6009 5.6945C11.7214 5.49619 11.6631 5.23567 11.4648 5.11124Z", fillOpacity: "1" }));
}
var IconCheckCircleFill = React.forwardRef(IconCheckCircleFillComponent);
export default IconCheckCircleFill;
